export default __webpack_public_path__ + "static/media/115t.650fdc19.jpg";